import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.trabalhadorafastamento.cadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionLista = ({dispatch},payload)=>{
    return serves.trabalhadorafastamento.lista(payload).then(res => {
        dispatch('ActionSetLista',res)
    }).catch(err => {
        dispatch('ActionSetLista',res)
    })
}
export const ActionPesquisa = ({dispatch},payload)=>{
    return serves.trabalhadorafastamento.pesquisa(payload).then(res => {
        dispatch('ActionSetCategorias',res)
    }).catch(err => {
        dispatch('ActionSetCategorias',res)
    })
}
export const ActionDeletar = ({dispatch},payload)=>{
    return serves.trabalhadorafastamento.delete(payload).then(res => {
        
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',res)
    })
}
export const ActionEditar = ({dispatch},payload)=>{
    return serves.trabalhadorafastamento.editar(payload).then(res => {
        dispatch('ActionSetEditar',res)
    }).catch(err => {
        dispatch('ActionSetEditar',err)
    })
}
export const ActionUpdate = ({dispatch},payload)=>{
    return serves.trabalhadorafastamento.update(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionPerfil = ({dispatch},payload)=>{
    return serves.trabalhadorafastamento.show(payload).then(res => {
        dispatch('ActionSetPerfil',res)
    }).catch(err => {
        dispatch('ActionSetPerfil',err)
    })
}
export const ActionUpdateEvento2230 = ({dispatch},payload)=>{
    return serves.trabalhadorafastamento.update2230(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionDeleteEvento2230 = ({dispatch},payload)=>{
    return serves.trabalhadorafastamento.delete2230(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionCadastroEvento2230 = ({dispatch},payload)=>{
    return serves.trabalhadorafastamento.cadastra2230(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionEventoShow = ({dispatch},payload)=>{
    return serves.trabalhadorafastamento.showevento(payload).then(res => {
        dispatch('ActionSetEvento',res)
    }).catch(err => {
        dispatch('ActionSetEvento',err)
    })
}
export const ActionSetLista = ({commit},payload) =>{
    commit(types.SET_LISTA,payload)
}
export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetEditar = ({commit},payload) =>{
    commit(types.SET_EDITAR,payload)
}
export const ActionSetCategorias = ({commit},payload) =>{
    commit(types.SET_CATEGORIAS,payload)
}
export const ActionSetPerfil = ({commit},payload) =>{
    commit(types.SET_PERFIL,payload)
}
export const ActionSetEvento = ({commit},payload) =>{
    commit(types.SET_EVENTO,payload)
}
